<template>
  <section>
    <h4>法寶流通 工作人員</h4>
    <h5>需求人員：</h5>
    <p>法寶流通 工作人員</p>
    <h5>工作性質：</h5>
    <p>書庫倉儲管理，信函、Email、電話、現場請書處理，經書法寶搬運包裝寄送，郵件包裹交寄，庫存盤點記錄等相關工作。</p>
    <h5>工作地點：</h5>
    <p>本會五股書庫 (新北市五股區)、杭州南路二樓書庫</p>
    <h5>需求條件：</h5>
    <p>
      1. 身心健全，能搬運法寶重物。<br>
      2. 高中職(以上)畢；備汽車駕照為佳。<br>
      3. 電腦基本操作，Word、Excel、E-mail處理。<br>
      4. 一般英文讀寫。<br>
      5. 願發心在佛教界工作，為三寶眾生服務奉獻，能與大眾和合相處，工作態度認真積極，富服務熱忱，協調性高，有責任感，已受三皈，具正知見之三寶弟子。
    </p>
    <p>
      ◎有意應徵者，敬請備妥：<br>
      1.詳細履歷、照片<br>
      2.自傳<br>
      3.詳述學佛歷程<br>
      4.發心至本會工作之因緣及對未來工作之期許，<br>
      函寄：台北市杭州南路一段55號11樓 朱師兄 收，<br>
      或 Email 至：<a href="mailto:budaedu@budaedu.org">budaedu@budaedu.org</a><br>
      TEL：<a href="tel:+886-2-23951198">{{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198</a>轉分機37
    </p>
    <p>※ 經本會審核後，另行約定面試時間；不適合者，恕不退件。</p>
  </section>
</template>
<script>
import Vue from 'vue'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: "warehouse-staff",
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>